import React, { useState } from "react";
import { useMutation } from "react-query";
import { SITE_ROLES } from "../../constants/roles";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useLeague from "../../hooks/queryResults/useLeague";
import useUsers from "../../hooks/queryResults/useUsers";
import useUrls from "../../hooks/useUrls";
import http from "../../services/httpService";
import Util from "../../util/util";
import Loading from "../ui/Loading";

export default function AdminPasswords() {
  const { league, leagueQuery } = useLeague();
  const { users, usersQuery } = useUsers();

  const [newPassword, setNewPassword] = useState({});
  const [changeStatus, setChangeStatus] = useState(null);
  const [focusedUsername, setFocusedUsername] = useState(null);

  const { apiUrl } = useUrls();

  const changePasswordMutation = useMutation(
    (data) => {
      setChangeStatus("updating...");
      const username = data.username;
      delete data.username;
      const url = `${apiUrl}/users/${username}/change-password`;
      const config = Util.addTokenToHeaders();
      console.log(`sending PATCH request to url ${url} with data:`, data);
      return http.patch(url, data, config);
    },
    {
      onSuccess: async () => {
        setChangeStatus("success");
        console.log("user password changed");
      },
      onError: (error) => {
        setChangeStatus("ERROR");
        console.log("user password change failed");
        console.error(error);
      },
    }
  );

  const isLoading = useIsLoading(leagueQuery, usersQuery, league, users);

  if (isLoading) return <Loading />;

  const handleInputChange = (event) => {
    setNewPassword((old) => ({
      ...old,
      [event.target.name]: event.target.value,
    }));
  };

  const handleChangeClick = (username) => {
    if (!newPassword[username]) {
      console.error(`no password set for username: ${username}!`);
      return;
    }
    console.log(
      `setting new password for username ${username} to ${newPassword[username]}`
    );
    setFocusedUsername(username);
    changePasswordMutation.mutate({
      username,
      newPassword: newPassword[username],
    });
  };

  return (
    <div>
      <h1>Admin - Change Passwords - {league.obj.name}</h1>
      <table>
        <thead>
          <tr>
            <th>First</th>
            <th>Last</th>
            <th>Username</th>
            <th>Role</th>
            <th>Password</th>
          </tr>
        </thead>
        <tbody>
          {users.items
            .filter((user) => user.obj.active)
            .sort((a, b) => {
              const al = a.obj.lastName;
              const bl = b.obj.lastName;
              if (al === bl) {
                const af = a.obj.firstName;
                const bf = b.obj.firstName;
                if (af === bf) return 0;
                return af < bf ? -1 : 1;
              }
              return al < bl ? -1 : 1;
            })
            .map((user) => {
              return (
                <tr key={user.obj.username}>
                  <td className={"left"}>{user.obj.firstName}</td>
                  <td className={"left"}>{user.obj.lastName}</td>
                  <td className={"left"}>{user.obj.username}</td>
                  <td className={"left"}>
                    {Util.getKeyByValue(SITE_ROLES, user.obj.siteRole)}
                  </td>
                  <td className={"left"}>
                    <input
                      name={user.obj.username}
                      onKeyUp={handleInputChange}
                      type={"text"}
                    />
                    <button
                      onClick={() => handleChangeClick(user.obj.username)}
                      className={"btn"}
                      style={{ marginLeft: "0.5rem" }}
                    >
                      Change
                    </button>
                    {focusedUsername === user.obj.username ? (
                      <span style={{ marginLeft: "1rem" }}>{changeStatus}</span>
                    ) : null}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}
